/* ===========================================================================
   ROVE NEXT — buy box: fabric heading, and the FOUR-CARD configurator.
   25 August 2026.

   Standing instruction, Sharon 25 Aug: "on the buy box for Ophelia and Reya it
   has to copy what the Diane is currently because we perfected it. The only
   difference is that Ophelia and Reya have add ons."

   WHY THIS IS CSS + JS AND NOT A CHANGE TO sections/rn-buybox.liquid
   That file is 129KB and shared by Diane, Ophelia, Reya and Alba. The API
   rewrites whole files, so a thirty-line change means retransmitting all of it
   with every PDP riding on the outcome.
   =========================================================================== */
(function () {
  var MAP = {
    'reya-form': {
      heading: 'Choose Your Configuration',
      note: 'Expandable later',
      /* NO label map any more. Sharon, 28 Aug: "remove the word modular from
         them ... no need for the word Modular inside those 4 selector. only in
         the selector we remove."

         This used to rewrite the option value into "2 Piece Curved Modular
         Sectional" for display (her 25 Aug request). Dropping the map lets the
         card fall through to c.size, which is the raw Shopify option value —
         "2 Piece Curved Sectional" — so the selector, the variant title and the
         cart now read identically with nothing to keep in sync.

         Deliberately NOT touched, because she scoped this to the selector: the
         product title, the config blocks' display_name (which travels into the
         cart as a line item property) and the homepage eyebrow all still say
         Modular. The homepage SELECTOR is changed to match, in
         sections/rn-hp-reya.liquid. */
    }
  };

  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  var bb = document.querySelector('[id^="rn-bb-"]');
  if (!bb) return;

  /* =========================================================================
     THE FABRIC HEADING NAMES THE FABRIC. IT DOES NOT ASK A QUESTION.

     Sharon, 25 Aug: "when I select a fabric it should not say choose your
     fabric, it should just name what the fabric is — Performance Plush Velvet
     Dune — exactly like how you have it on the Diane PDP."

     Runs on EVERY PDP, because the instruction is general: the Ophelia and
     Reya buy boxes should copy Diane's, add-ons aside. It also fixed Diane
     itself, which was gaining a stray "|" after the first swatch click.

     The permanent home is the fabric_label / fabric_label_prefix settings in
     each product template. It is done here as well so the two cannot drift:
     the buy box controller rewrites this label on every swatch change, so a
     template-only fix would still need something watching it.
     ========================================================================= */
  (function normaliseFabricLabel() {
    var el = bb.querySelector('[data-fabric-label]');
    if (!el) return;
    var fix = function () {
      var t = el.textContent || '';
      var out = t.replace(/^\s*choose\s+your\s+fabric\s*/i, '')
                 .replace(/^\s*[|–—-]\s*/, '')
                 .trim();
      if (!out) return;
      if (!/^performance\b/i.test(out)) out = 'Performance ' + out;
      out = out.replace(/^(Performance)\s*\|\s*/i, '$1 ');
      if (out !== t) el.textContent = out;
    };
    fix();
    if (window.MutationObserver) {
      new MutationObserver(function () { fix(); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    }
  })();

  var cfg = MAP[handle];
  if (!cfg) return;
  var grid = bb.querySelector('[data-bb-cfg]');
  var json = bb.querySelector('[data-bb-cfgjson]');
  if (!grid || !json) return;

  var combos;
  try { combos = JSON.parse(json.textContent); } catch (e) { return; }
  if (!combos || combos.length < 3) return;   /* two axes are fine for 2 combos */

  var rows = [].slice.call(grid.querySelectorAll('.bb-cfgrow'));
  var sizeAxis   = grid.querySelector('[data-cfg-axis="size"]');
  var chaiseAxis = grid.querySelector('[data-cfg-axis="chaise"]');
  if (!sizeAxis || !chaiseAxis) return;

  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
           + '<path d="M2.6 8.4l3.5 3.5 7.3-7.8" fill="none" stroke="currentColor"'
           + ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function press(axis, key) {
    var b = [].slice.call(axis.querySelectorAll('[data-cfg-key]')).filter(function (x) {
      return x.getAttribute('data-cfg-key') === key;
    })[0];
    if (b) b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  }

  /* ---- build ------------------------------------------------------------ */
  var wrap = document.createElement('div');
  wrap.className = 'bb-cfgrow rn-cfg4';
  wrap.setAttribute('data-rn-cfg4', '');

  var head = document.createElement('div');
  head.className = 'rn-cfg4-head';
  var lab = document.createElement('p');
  lab.className = 'bb-lab';
  lab.textContent = cfg.heading;
  head.appendChild(lab);
  if (cfg.note) {
    var n = document.createElement('span');
    n.className = 'rn-cfg4-note';
    n.textContent = cfg.note;
    head.appendChild(n);
  }
  wrap.appendChild(head);

  var list = document.createElement('div');
  list.className = 'rn-cfg4-grid';
  wrap.appendChild(list);

  combos.forEach(function (c) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rn-cfg4-opt';
    b.setAttribute('data-size', c.size);
    b.setAttribute('data-chaise', c.chaise);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML =
      '<span class="sil">' + (c.sil ? '<img alt="" loading="lazy">' : '') + '</span>' +
      '<span class="tick">' + TICK + '</span>' +
      '<b></b><span class="sub"></span>';
    if (c.sil) {
      var im = b.querySelector('img');
      /* THE HOMEPAGE USES THE PHOTOGRAPH, NOT THE CUT-OUT.

         The template's silhouette setting points at Reya_..._Cut_Out.png, a
         TRANSPARENT 600x275 file. Dropped into a 139x104 frame it can only be
         letterboxed, and the frame colour shows through as the beige bands
         Sharon reported. The homepage instead uses Reya_..._Display_1.jpg —
         the same configuration photographed on the gold backdrop — at
         object-fit:cover, so the picture fills the card.

         The two filenames differ only in that suffix, so the photograph is
         derived from the cut-out and the cut-out stays as the fallback if the
         derived file is ever missing. */
      var photo = c.sil.replace(/_Cut_Out\.png/i, '_Display_1.jpg');
      if (photo !== c.sil) {
        im.addEventListener('error', function once() {
          im.removeEventListener('error', once);
          im.src = c.sil;
        });
      }
      im.src = photo;
    }
    b.querySelector('b').textContent = (cfg.label && cfg.label[c.size]) || c.size;
    b.querySelector('.sub').textContent = c.chaise;
    b.addEventListener('click', function () {
      /* order matters: size first, then chaise, so the controller resolves the
         final pair once rather than flickering through an invalid combination */
      if (grid.getAttribute('data-cur-size') !== c.size) press(sizeAxis, c.size);
      setTimeout(function () {
        if (grid.getAttribute('data-cur-chaise') !== c.chaise) press(chaiseAxis, c.chaise);
        setTimeout(sync, 30);
      }, 20);
    });
    list.appendChild(b);
  });

  rows[0].parentNode.insertBefore(wrap, rows[0]);

  /* the originals stay in the DOM because they ARE the mechanism */
  rows.forEach(function (r) { r.classList.add('rn-cfg4-hidden'); });

  /* ---- keep the selected state in step ---------------------------------- */
  function sync() {
    var s = grid.getAttribute('data-cur-size');
    var c = grid.getAttribute('data-cur-chaise');
    [].slice.call(list.children).forEach(function (b) {
      var on = b.getAttribute('data-size') === s && b.getAttribute('data-chaise') === c;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  sync();
  if (window.MutationObserver) {
    new MutationObserver(function () { setTimeout(sync, 20); })
      .observe(grid, { attributes: true, attributeFilter: ['data-cur-size', 'data-cur-chaise'] });
  }

  /* ---- brief: "Remove SKU from the primary buy box" --------------------- */
  var sku = bb.querySelector('[data-bb-sku]');
  if (sku && sku.parentNode) sku.parentNode.removeChild(sku);

  /* =========================================================================
     PUT THE BUY BOX IN THE ORDER DIANE USES.

     Measured before this ran: the cards ended at y=699 and the fabric swatches
     did not start until y=996 — below the fold. Sharon: "the swatch is not even
     in the same screen so i can select colour." Two real blocks sat between
     them, the configuration summary and the Built to Evolve panel.

     Diane's order is: title, price, rating, availability, value card, proof
     row, FABRIC, add to cart, reassurance, delivery, protection, accordions.
     The configuration block slots in AFTER fabric and before the summary, so
     colour is chosen first — which is what Sharon asked for.
     ========================================================================= */
  var form = bb.querySelector('form.bb-form, [data-bb-form]');
  var swatches = bb.querySelector('.bb-swatches');
  var fabricSect = swatches ? swatches.closest('.bb-sect') : null;
  var summary = bb.querySelector('.bb-cfgname');
  var evolve = bb.querySelector('.bb-evolve');
  var cfgBlock = grid;

  if (form && form.parentNode) {
    if (fabricSect && cfgBlock.parentNode === fabricSect.parentNode) {
      cfgBlock.parentNode.insertBefore(fabricSect, cfgBlock);
    }
    if (summary) form.parentNode.insertBefore(summary, form);
    if (evolve) form.parentNode.insertBefore(evolve, form.nextSibling);
  }
})();
